export default "__VITE_ASSET__gqxm5PrD__"